import { useEffect, useState } from "react";

import { CountryBrandApplicationAttachments } from "../../../../domain/CountryBrandApplication";
import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function SustainabilityReporting() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { sustainabilityReportingValue = "SI", sustainabilityReportingComment } =
		countryBrandApplication;
	const [attachments, setAttachments] = useState<CountryBrandApplicationAttachments[]>(
		countryBrandApplication.attachments
	);
	const [attach, setAttach] = useState(sustainabilityReportingValue === "SI");
	const sustainabilityReportingAttachments = attachments.filter(
		(e) => e.type === "SustainabilityReporting" && e.status !== "DELETE"
	);

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		const submitStepData = () => {
			const sustainabilityReportingValue =
				formRef.current.elements.sustainabilityReportingValue.value;
			const sustainabilityReportingComment =
				formRef.current.elements.sustainabilityReportingComment.value;

			update({
				data: {
					sustainabilityReportingValue,
					sustainabilityReportingComment,
					attachments,
				},
				nextStep: currentStep + 1,
			});
		};
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, [attachments]);

	function handleChange() {
		formRef.current.elements.sustainabilityReportingValue.value === "SI"
			? setAttach(true)
			: setAttach(false);
	}

	async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files[0];
		if (file) {
			const type = e.target.name;
			const id = file.name + type;
			setAttachments([
				...attachments
					.filter((att) => !(att.name === file.name && att.type === type && att.status === "ADD"))
					.map((att) =>
						att.name === file.name && att.type === type ? { ...att, status: "DELETE" } : { ...att }
					),
				{
					id,
					name: file.name,
					url: "",
					type: e.target.name,
					status: "ADD",
					file,
				},
			]);
		}
		e.target.value = null;
	}

	function handleClickDeleteRow(attachment: CountryBrandApplicationAttachments) {
		if (attachment.status === "ADD") {
			setAttachments(attachments.filter((e) => e.id !== attachment.id));
		} else {
			setAttachments(
				attachments.map((e) => (e.id === attachment.id ? { ...e, status: "DELETE" } : { ...e }))
			);
		}
	}

	return (
		<div className="step-page" id="step-13">
			<section>
				<h3>13.b - Realiza reportes de sostenibilidad</h3>
				<select
					name="sustainabilityReportingValue"
					defaultValue={sustainabilityReportingValue}
					onChange={handleChange}
				>
					<option value="SI">SI</option>
					<option value="NO">NO</option>
				</select>
				{attach && (
					<>
						<label htmlFor="sustainabilityReportingAttach">
							Adjuntar archivos
							<input type="file" name="SustainabilityReporting" onChange={handleFileChange} />
						</label>
						<ul className="attachments-list">
							{sustainabilityReportingAttachments.map((e) => {
								return (
									<li key={e.id} className="attachment-item">
										{e.status !== "ADD" ? (
											<a
												className="button btn-small"
												download={true}
												href={e.url}
												target="_blank"
												rel="noreferrer"
											>
												{e.name}
											</a>
										) : (
											<span>{e.name}</span>
										)}
										<button
											className="btn-small"
											type="button"
											onClick={() => handleClickDeleteRow(e)}
										>
											Borrar
										</button>
									</li>
								);
							})}
						</ul>
					</>
				)}
				<label htmlFor="commsustainabilityReportingCommentent">
					Comentarios / Observaciones:
					<textarea
						name="sustainabilityReportingComment"
						defaultValue={sustainabilityReportingComment}
					/>
				</label>
			</section>
		</div>
	);
}

export { SustainabilityReporting };
